var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-level2',_vm._g(_vm._b({staticClass:"view-loyalty-config"},'layout-level2',_vm.attrs,false),_vm.listeners),[(!_vm.loading)?_c('router-view',{attrs:{"loading":_vm.loading,"errors":_vm.errors,"read-only":_vm.isReadOnly,"dirty-vouchers":_vm.dirtyVouchers},on:{"icon":_vm.onIcon,"logo":_vm.onLogo,"strip":_vm.onStrip}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }